import { PaymentPlanId, resolveEffectivePlan, type EffectivePlanUser } from "../../payment/plans";

/**
 * Modes d'affichage. Lite = pages prêtes à l'emploi ; Advanced = l'app à
 * widgets historique. Free est toujours en Lite ; les plans payants choisissent,
 * Lite par défaut (préférence absente = Lite).
 */
export type UiMode = "lite" | "advanced";

export function canUseAdvancedMode(user: EffectivePlanUser): boolean {
  return resolveEffectivePlan(user) !== PaymentPlanId.Free;
}

export function resolveUiMode(user: EffectivePlanUser, preference: UiMode | null): UiMode {
  if (!canUseAdvancedMode(user)) return "lite";
  return preference ?? "lite";
}

export function parseUiMode(raw: string | null | undefined): UiMode | null {
  return raw === "lite" || raw === "advanced" ? raw : null;
}
